import React from 'react';
import { BootstrapModal } from 'shared-components/modal/bootstrap-modal';

export class PermissionModal extends React.Component {
  constructor (props) {
    super(props);
    this.closeModal = this.closeModal.bind(this);
  }

  closeModal () {
    this.props.toggleModal('');
  }

  render () {
    return (
      <BootstrapModal
        {...this.props}
        modalClass="permission-modal"
        header={
          <h3>You don’t have access</h3>
        }
        body={
          <div>
            <div className="text-gray-dark">
              Please contact the owner of the board to get access to votes and comments.
            </div>
            <button className="btn btn-block btn-primary form" onClick={this.closeModal}>Got it</button>
          </div>
        }
      />
    );
  }
}
